module.exports = __webpack_public_path__ + "media/components/maps/forms/images/restriction-zone-amber-60337b0d96c7b6c76f1316b377f43368.svg";